// extracted by mini-css-extract-plugin
export default {"SearchInput":"SearchInput_SearchInput__K+tYk","SearchIconWrapper":"SearchInput_SearchIconWrapper__kfCV6","SearchIcon":"SearchInput_SearchIcon__nJTXs"};